import axios from './http'

class AuthService {
  constructor() {
    const token = this.getToken()
    if (token) {
      this.setToken(token)
    }
  }
  getToken() {
    return localStorage.getItem('token')
  }
  setToken(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

    localStorage.setItem('token', token)
  }
  clearToken() {
    localStorage.removeItem('token')
    delete axios.defaults.headers.common['Authorization']
  }
}

export { AuthService }
